import React from "react";

function CouponFlash({ item }) {
  if (!item) return null;

  const isPercent = item.discountType === "PERCENTAGE";

  return (
    <div className="custom-coupon-marquee-item">

      <span className="custom-coupon-text">
        {item.title}{" "}
      </span>

      <span className="custom-coupon-dot"> — </span>

      <span className="custom-coupon-offer">
        {isPercent
          ? `EXTRA ${item.discountValue}% OFF`
          : `FLAT ₹${item.discountValue} OFF`}
      </span>

      <span className="custom-coupon-dot">—</span>

      <span className="custom-coupon-use">
        USE CODE{" "}
      </span>

      <span className="custom-coupon-code">
        {item.code}{" "}
      </span>

      <span className="custom-coupon-dot">✦</span>

    </div>
  );
}

export default CouponFlash;